<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
    Launch demo modal
  </button>
  
  <!-- Modal -->
   
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="argument">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">User Information</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            
            <form (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                            <label for="fName" class="form-label">First Name</label>
                            <input type="text" class="form-control" id="fName">
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="lName" class="form-label">Last Name</label>
                        <input type="text" class="form-control" id="lName">
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <label for="company" class="form-label">Company</label>
                        <input type="text" class="form-control" id="company">
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="city" class="form-label">City</label>
                        <input type="text" class="form-control" id="city">
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <label for="state" class="form-label">State</label>
                        <input type="text" class="form-control" id="state">
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="country" class="form-label">Country</label>
                        <input type="text" class="form-control" id="country">
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6">
                        <label for="email" class="form-label">Email</label>
                        <input type="email" class="form-control" id="email">
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <label for="lName" class="form-label">Phone Number</label>
                        <input type="text" class="form-control" id="phone">
                    </div>
                </div>
                <div class="mb-3">
                  
                  
                  <!-- <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div> -->
                </div>
                <!-- <div class="mb-3">
                  <label for="exampleInputPassword1" class="form-label">Password</label>
                  <input type="password" class="form-control" id="exampleInputPassword1">
                </div> -->
                <div class="mb-3 form-check">
                  <input type="checkbox" class="form-check-input" id="exampleCheck1">
                  <label class="form-check-label" for="exampleCheck1">	
                    I have read and agree to the <a href="https://www.timken.com/privacy-statement/" target="_blank" style="text-decoration: underline;">Privacy Policy</a>, <a href="https://www.timken.com/terms-of-use/" target="_blank" style="text-decoration: underline;">Terms of Service </a>, and the <a href="#" id="PrivacyLink" style="text-decoration: underline;">applicable terms and conditions</a>.
                    </label>
                </div>
                <!-- <button type="submit" class="btn btn-primary">Submit</button> -->
              </form>
            
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>
      </div>
    </div>
  </div>